import Vue from "vue";
import Vuex from "vuex";

// 该指令必须在 store 创建之前执行
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
    title: '',
    stashInfo: {
        
      }
    },
    mutations: { /* 更改state中值的方法 */
        changeTitle(state,data) {
            state.title = data
      },
      setStash(state,data) {
        state.stashInfo=data
      }
    },
    actions: {
        
    },
    getters: {
    },
    modules: {},
    
})